import { Component, inject } from '@angular/core';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';

@Component({
  selector: 'brand-settings',
  templateUrl: './brand-settings.component.html',
})
export class BrandSettingsComponent {
  private companyStateService = inject(CompanyStateService);

  readonly companyName: string =
    this.companyStateService.getSelectedCompanyName();
}
